import type { FC, ReactNode } from "react";
import {
  type CarReservationDetailSummaryProps,
  CoreCarsComponent,
  useCarsStyles,
} from "@apac/components/cars";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CarCheckoutDateRange, CarCard } from "@tenant/cars";
import clsx from "clsx";
import defaultStyles from "./CarReservationDetailSummary.module.scss";
import { mapCarReservationToCarCardProps } from "./util";

interface ExtendedCarReservationDetailSummaryProps
  extends CarReservationDetailSummaryProps {
  title?: ReactNode;
  cta?: ReactNode;
}

export const CarReservationDetailSummary: FC<
  ExtendedCarReservationDetailSummaryProps
> = ({ reservation, className, title, cta }) => {
  const styles = useCarsStyles(
    CoreCarsComponent.CarReservationDetailSummary,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreCarsComponent.CarReservationDetailSummary
  );
  const carCardProps = mapCarReservationToCarCardProps(reservation);

  return (
    <CarCard {...carCardProps} className={clsx(block, className)}>
      {title && <div className={cn("title")}>{title}</div>}
      <CarCheckoutDateRange
        className={cn("date-range")}
        pickupTime={reservation.pickUp.dateTime}
        dropoffTime={reservation.dropOff.dateTime}
      />
      {cta && <div className={cn("cta")}>{cta}</div>}
    </CarCard>
  );
};
